import { render, staticRenderFns } from "./RiderListViews.vue?vue&type=template&id=6f078bbe&scoped=true"
import script from "./RiderListViews.vue?vue&type=script&lang=js"
export * from "./RiderListViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f078bbe",
  null
  
)

export default component.exports